import styled from "styled-components";

export const Container = styled.div`
  position: relative;

  input {
    padding-right: 2.5rem;
  }

  button {
    background: none;
    border: none;
    position: absolute;
    right: 0.8rem;
    bottom: 0.45rem;
    color: #cedde0;
    font-size: 1.6rem;

    :hover {
      cursor: pointer;
    }
  }
`;
